import React from 'react';
import cx from 'classnames';
import './LabelInfo.scss';

const LabelInfo = (props) => {
  const { className, label, info } = props;

  return (
    <div className={cx('label-info', className)}>
      <span className="label">{label}</span>
      <span className="info">{info}</span>
    </div>
  );
};

export default LabelInfo;
